module.exports = __webpack_public_path__ + "img/1521889118.4411009c.jpg";